import { Button } from "nq-component";
import React from "react";
import { findObjectUseCase } from "../../../usecases/object";
import { FloatingForm } from "../../../components/common/Converter";
import CardView from "../../../components/common/CardView";
import InputFactory from "../../../components/InputFactory";
import BaseFormPage from "../../../base/BaseFormPage";
import PayrollListFormPresenter from "./PayrollListFormPresenter";
import PrintableDisbursmentVoucher from "./PrintDisbursementVoucher/PrintableDisbursmentVoucher";
import { getDefaultAttachments } from "./default-attachments/DefaultAttachmentsPage";
import {
  _getAccountsTitle,
  _classifyDebitCredit,
  getHighestEducationalBackground,
} from "./helper/helperFunction";
import { fetchHierarchyItem } from "../../../utils/hierarchy";

export default class PayrollListForm extends BaseFormPage {
  constructor(props) {
    super(props);
    this.presenter = new PayrollListFormPresenter(this);
    this.state = {
      dvNumber: "",
      signatories: {
        firstName: "CHESTER KEVIN S. SY" || "",
        firstPosition: "Chief, Accounting Section" || "",
        secondName: "MARY ANN Q. CARANTO" || "",
        secondPosition: "Chief, Administrative Division" || "",
      },
      attachmentsList: [],
      attachments: "",
      editingIndex: null,
      hoveredIndex: null,
      payrollAmntLists: {},
      payrollData: [],
      titleAccLists: [],
      otherPayrollData: [],
      isPayrollDataLoading: true,
      payrollItems: [],
      hierarchyItem: {},
      bachelorsDegree: "",
      serviceEligibility: "",
    };
    this.contractPDF = React.createRef();
  }

  async componentDidMount() {
    const { objectData, isBackpay } = this.props;
    const { payrollType } = objectData;

    const id = objectData?.id;
    this._setDefaultAttachments(objectData);

    try {
      const [payrollData, accountsTitle, backPay, incentives] =
        await Promise.all([
          findObjectUseCase().execute("payroll", {
            where: { payrollID: id },
            include: [
              "employee", 
              "employee.position", 
              "employee.nonRegPosition"
            ],
          }),
          findObjectUseCase().execute("accounts_title"),
          findObjectUseCase().execute("payroll_back_pay", {
            where: { payrollID: id },
            include: ["employee", "employee.position", "employee.nonRegPosition"],
          }),
          findObjectUseCase().execute("incentive", {
            include: ["allowanceType"],
          }),
        ]);

        console.log("payrollData1", payrollData);

      const payrollItems = isBackpay ? backPay : payrollData;
      const params_1 = {
        payrollItems,
        objectData,
        accountsTitle,
      };

      if(objectData?.jobType === "Job Order" && (objectData?.payItem === "Initial Salary" || objectData?.payItem === "Last Salary")) {
        const payrollItem = payrollItems?.[0]?.employee;

        const [hierarchyItem, educationalBackground, serviceEligibility] = await Promise.all([
          fetchHierarchyItem(
            findObjectUseCase(),
            payrollItem,
          ),
          findObjectUseCase().execute("educational_background", {
            where: {
              empID: payrollItem?.id,
            },
            sort: {
              createdAt: -1,
            },
            keys: ["educationLevel","educationDegree"]
          }),
          findObjectUseCase().execute("service_eligibility", {
            where: {
              empID: payrollItem?.id,
            },
            sort: {
              createdAt: -1
            },
            limit: 1,
            keys: ["civilCareer"]
          }),
        ]);

        this.setState({ 
          hierarchyItem: hierarchyItem?.[0], 
          bachelorsDegree: getHighestEducationalBackground(educationalBackground),
          serviceEligibility: serviceEligibility?.[0]
         });
      }

      console.log("payrollItems", payrollItems);

      const titleAccLists = _getAccountsTitle(params_1);

      let categorized = [];
      if (payrollType === "Special Payroll") {
        const incentiveType = incentives.find(
          (item) => item?.allowanceType?.AllowanceType === objectData?.payItem
        );

        categorized = _classifyDebitCredit(titleAccLists, incentiveType);
      }

      const contributionLists = this.presenter._sumAllContributions(params_1);
      const otherPayrollData = this.presenter._sumOtherPayrollData(params_1);

    // const params_2 = {
    //   contributionLists,
    //   otherPayrollData,
    //   titleAccLists,
    //   categorized,
    //   ...params_1,
    // };

      const cashTotal = this.presenter.calculateNetTotal(
        contributionLists,
        otherPayrollData,
        titleAccLists,
        objectData,
        categorized
      );

      const netPayTotal = this.presenter.calculateNetPayTotal(payrollItems);

      const dynamicLabel = this.presenter.getDynamicLabel(
        backPay,
        objectData,
        payrollData,
        contributionLists,
        titleAccLists
      );

      const backpayDate = this.presenter.getBackpayDate(backPay);

      const payrollAmntLists = {
        titleAccLists,
        contributionLists,
        otherPayrollData,
        cashTotal,
        netPayTotal,
        dynamicLabel,
        backpayDate,
        categorized,
      };

      console.log("payrollAmntLists", payrollAmntLists);

      this.setState({ payrollData, payrollAmntLists, backPay, payrollItems });
    } catch (error) {
      console.log(error, "Failed to load payroll data");
      this.showError(error);
    } finally {
      this.setState({ isPayrollDataLoading: false });
    }
  }

  componentDidUpdate(prevProps) {
    const { objectData } = this.props;
    if (
      prevProps.objectData.payrollType !== this.props.objectData.payrollType
    ) {
      this._setDefaultAttachments(objectData);
    }
  }

  getCollectionName() {
    return "employee_payroll";
  }

  _hanldeSignatoryLbl(value, field) {
    this.setState((prevState) => ({
      signatories: {
        ...prevState.signatories,
        [field]: value,
      },
    }));
  }

  _handleDvNumber(value) {
    this.setState({ dvNumber: value });
  }

  _handleAttachments(attachments) {
    this.setState({ attachments });
  }

  _handleAttachmentPress = (event) => {
    const { attachments, attachmentsList, editingIndex } = this.state;
    if (event.key === "Enter" && attachments.trim()) {
      event.preventDefault();

      if (editingIndex !== null) {
        const updatedDeductions = attachmentsList.map((name, index) =>
          index === editingIndex ? attachments.trim() : name
        );

        this.setState({
          attachmentsList: updatedDeductions,
          attachments: "",
          editingIndex: null,
        });
      } else {
        this.setState({
          attachmentsList: [...attachmentsList, attachments.trim()],
          attachments: "",
        });
      }
    }
  };

  _handleEditAttachments(index) {
    this.setState({
      attachments: this.state.attachmentsList[index],
      editingIndex: index,
    });
  }

  _handleDeleteAttachments(index) {
    const { attachmentsList } = this.state;
    const updatedDeductions = attachmentsList.filter((_, i) => i !== index);
    this.setState({ attachmentsList: updatedDeductions, hoveredIndex: null });
  }

  _handleHover = (event, index) => {
    if (event.type === "mouseenter") {
      this.setState({ hoveredIndex: index });
    } else if (event.type === "mouseleave") {
      this.setState({ hoveredIndex: null });
    }
  };

  _setDefaultAttachments(objectData) {
    this.setState({
      attachmentsList: getDefaultAttachments(objectData),
    });
  }

  handleCancel = () => {
    this.props.closeModal();
  };

  render() {
    const { objectData } = this.props;
    const {
      dvNumber,
      attachments,
      attachmentsList,
      hoveredIndex,
      payrollData,
      payrollAmntLists,
      backPay,
      signatories,
      object,
      isPayrollDataLoading,
    } = this.state;

    return (
      <>
        <FloatingForm width="50%">
          <div className="d-none">
            <div ref={this.contractPDF} id="contractPDF">
              <PrintableDisbursmentVoucher
                object={{ ...objectData, dvNumber }}
                payrollData={payrollData}
                backPayData={backPay}
                attachmentsList={attachmentsList}
                payrollAmntLists={payrollAmntLists}
                backPay={backPay}
                otherData={{
                  signatories,
                  actualData: this.state.payrollItems,
                  hierarchyItem: this.state.hierarchyItem,
                  bachelorsDegree: this.state.bachelorsDegree,
                  serviceEligibility: this.state.serviceEligibility,
                }}
              />
            </div>
          </div>
          <CardView>
            {" "}
            <h4 className="p-2">Please Input Necessary details!</h4>
            <hr></hr>
            <div className=" d-flex row  p-3 gap-2">
              <div className="col-md-12">
                <label>
                  <strong>DV No.</strong> <span className="text-danger">*</span>
                </label>
                <InputFactory
                  className="mb-2"
                  type="String"
                  value={dvNumber}
                  onChange={this._handleDvNumber.bind(this)}
                  placeholder="Enter DV No."
                  required={true}
                />
              </div>
              <label>
                <strong>Signatories</strong>
              </label>
              <div className="col-md-12">
                {[
                  {
                    label: "Signature 1",
                    fields: [
                      { key: "firstName", placeholder: "Name" },
                      { key: "firstPosition", placeholder: "Position" },
                    ],
                  },
                  {
                    label: "Signature 2",
                    fields: [
                      { key: "secondName", placeholder: "Name" },
                      { key: "secondPosition", placeholder: "Position" },
                    ],
                  },
                ].map((signature, idx) => (
                  <div key={idx}>
                    <label>{signature.label}</label>
                    {signature.fields.map((field, fieldIndex) => (
                      <InputFactory
                        key={fieldIndex}
                        className="mb-2"
                        type="String"
                        value={signatories?.[field.key]}
                        onChange={(value) =>
                          this._hanldeSignatoryLbl(value, field.key)
                        }
                        placeholder={field.placeholder}
                      />
                    ))}
                  </div>
                ))}
              </div>

              <div className="p-0">
                <label>
                  Attachments <span className="text-danger">*</span>
                </label>
                <InputFactory
                  type="String"
                  field="attachments"
                  value={attachments}
                  onChange={this._handleAttachments.bind(this)}
                  onKeyDown={this._handleAttachmentPress}
                  required={false}
                />
                <div className="mt-2">
                  {attachmentsList.map((name, index) => (
                    <div
                      key={index}
                      className="d-inline-flex align-items-center me-2 mb-2 bg-light rounded"
                    >
                      <div
                        style={{ padding: "2px 6px" }}
                        className="me-2"
                        onClick={() => this._handleEditAttachments(index)}
                      >
                        {name}
                      </div>
                      <div
                        className=""
                        style={{
                          borderBottomRightRadius: "4px",
                          borderTopRightRadius: "4px",
                          padding: "2px 4px",
                          backgroundColor:
                            hoveredIndex === index
                              ? "rgb(49, 88, 164)"
                              : "rgb(41, 69, 124)",
                        }}
                        onMouseEnter={(e) => this._handleHover(e, index)}
                        onMouseLeave={(e) => this._handleHover(e, index)}
                      >
                        <i
                          style={{ color: "#fff" }}
                          className="bi bi-x"
                          aria-label="Close"
                          onClick={(e) => {
                            this._handleDeleteAttachments(index);
                          }}
                        ></i>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="w-100 d-flex justify-content-end gap-2 mb-3 pe-3">
                <hr></hr>
                <Button
                  type="button"
                  className="btn btn-primary"
                  disabled={isPayrollDataLoading}
                  onClick={() => this.presenter._handleNextBtn()}
                >
                  <span
                  className="position-relative d-inline-flex align-items-center justify-content-center"
                    style={{ minWidth: "88px", minHeight: "20px" }}
                  >
                    <span
                    className="position-absolute left-0 right-0 top-50 translate-middle-y d-inline-flex align-items-center justify-content-center"
                      style={{
                        opacity: isPayrollDataLoading ? 1 : 0,
                        transition: "opacity 220ms ease-in-out",
                        pointerEvents: "none",
                      }}
                    >
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      />
                      Loading...
                    </span>
                    <span
                      style={{
                        opacity: isPayrollDataLoading ? 0 : 1,
                        transition: "opacity 220ms ease-in-out",
                        pointerEvents: "none",
                      }}
                    >
                      Next
                    </span>
                  </span>
                </Button>
                <Button className="btn btn-light" onClick={this.handleCancel}>
                  Cancel
                </Button>
              </div>
            </div>
          </CardView>
        </FloatingForm>
      </>
    );
  }
}
